import init from './init';
import logger from 'logger';

init().catch((err) => {
    logger.error(`${err.message}\n${err.stack}`);
});
